// @flow
import { createAction } from 'redux-actions';

export const appLoaded = createAction('hive/application/APP_LOADED');
export const attemptLogIn = createAction('hive/application/ATTEMPT_LOG_IN');
export const logIn = createAction('hive/application/LOG_IN');
export const logInComplete = createAction('hive/application/LOG_IN_COMPLETE');
export const logInReset = createAction('hive/application/LOG_IN_RESET');
export const logOut = createAction('hive/application/LOG_OUT');
export const ResetState = createAction('hive/application/RESET_STATE');
export const showHiveLiveModal = createAction('hive/application/SHOW_HIVE_LIVE_MODAL');
export const hideHiveLiveModal = createAction('hive/application/HIDE_HIVE_LIVE_MODAL');
export const receiveGTMOffers = createAction('hive/application/RECEIVE_GTM_OFFERS');
export const showWelcomeMessage = createAction('hive/application/SHOW_WELCOME_MESSAGE');
export const hideWelcomeMessage = createAction('hive/application/HIDE_WELCOME_MESSAGE');
export const showLeakSensorModal = createAction('hive/application/SHOW_LEAK_SENSOR_MODAL');
export const hideLeakSensorModal = createAction('hive/application/HIDE_LEAK_SENSOR_MODAL');
export const showHumidityControl = createAction('hive/application/SHOW_HUMIDITY_CONTROL');
export const hideHumidityControl = createAction('hive/application/HIDE_HUMIDITY_CONTROL');
export const startLoginAnimation = createAction('hive/application/START_LOGIN_ANIMATION');
export const stopLoginAnimation = createAction('hive/application/STOP_LOGIN_ANIMATION');



// WEBPACK FOOTER //
// ./src/core/state/application/actions.js